var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',_vm._g({attrs:{"css":false,"mode":"out-in"}},_vm.transition),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }